




import { Component, Prop, Vue } from "vue-property-decorator";

import { AutomaticReport } from "@/models";
import DetailsTable from "@/components/Agencies/ReportBuilder/DetailsTable.vue";
import {
  DetailRow,
  DetailSection,
  buildCompetitorDetailRows,
  formatBackendDate,
  profileLabel,
  timeSlotsValue,
  userLabel,
} from "@/components/Agencies/ReportBuilder/competitorDetailRows";
import { describeGranularity } from "@/components/Agencies/ReportBuilder/automaticReport";

@Component({ components: { DetailsTable } })
export default class AutomaticReportDetailsTable extends Vue {
  @Prop({ required: true }) readonly automaticReport!: AutomaticReport;

  displayName(automaticReport: AutomaticReport): string {
    return automaticReport.name || `Report #${automaticReport.id}`;
  }

  get sections(): DetailSection[] {
    const automaticReport = this.automaticReport;

    const generalRows: DetailRow[] = [
      { label: "Nome", value: this.displayName(automaticReport) },
    ];
    if (automaticReport.profile) {
      generalRows.push({
        label: "Profilo",
        value: profileLabel(automaticReport.profile),
      });
    }
    if (automaticReport.user) {
      generalRows.push({
        label: "Utente",
        value: userLabel(automaticReport.user),
      });
    }
    generalRows.push({
      label: "Stato",
      value: automaticReport.active ? "Attivo" : "Non attivo",
    });

    const recurrenceRows: DetailRow[] = [
      {
        label: "Dimensione estrazione",
        value: describeGranularity(automaticReport),
      },
    ];

    const competitor = automaticReport.competitor;
    if (competitor) {
      recurrenceRows.push({
        label: "Confronto",
        value: competitor.compare ? "sì" : "no",
      });
      if (competitor.compare) {
        recurrenceRows.push({
          label: "Periodo di confronto",
          value: `${formatBackendDate(
            competitor.comparisonStartsAt
          )} → ${formatBackendDate(competitor.comparisonEndsAt)}`,
        });
      }
      recurrenceRows.push({
        label: "Fasce orarie",
        value: timeSlotsValue(competitor.timeSlotsFilter),
      });
    }

    const sections: DetailSection[] = [
      { title: "Informazioni generali", rows: generalRows },
      { title: "Ricorrenza", rows: recurrenceRows },
    ];

    const templateCompetitor = automaticReport.reportTemplate?.competitor;
    if (templateCompetitor) {
      const rows = buildCompetitorDetailRows(templateCompetitor);
      if (rows.length) {
        sections.push({ title: "Configurazione", rows });
      }
    }

    return sections;
  }
}
